<template>
  <div class="new">
    <div class="container">
      <div class="new__wrapper">
        <new-password-form />
      </div>
    </div>
  </div>
</template>

<script setup>
import NewPasswordForm from "@/components/forms/new-password-form.vue";
</script>

<style lang="scss" scoped>
.new {
  background-image: url(@images/authBg.png);
  background-repeat: no-repeat;
  background-size: cover;

  &__wrapper {
    padding-block: 100px 175px;
    display: grid;
    place-items: center;
  }
}
</style>